import { createFileRoute } from '@tanstack/react-router'
import { DelegationOfAuthorityPage } from '../-components/DelegationOfAuthorityPage'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-no-deviation/',
)({
  component: () => <DelegationOfAuthorityPage type="single_no_deviation" />,
})
